import React from 'react';
import './About.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faChalkboardTeacher, faFileInvoice, faShoppingCart, faPhone } from '@fortawesome/free-solid-svg-icons';
import AboutImage from '../../assets/about/about.jpg';

export default function About() {
    return (
        <>
            <section id="about">
                <div className="container">
                    <div className="title_headling">
                        <h3>About Us</h3>
                        <p>We are a dedicated team providing innovative solutions to help businesses succeed in an ever-changing world. Our mission is to support organizations with expert knowledge and efficient services.</p>
                    </div>
                    <div className="about_box_wrapper">
                        <div className="about_box">
                            <div className="about_icon">
                                <FontAwesomeIcon icon={faBriefcase} />
                            </div>
                            <div className="about_content">
                                <h5>Our Story</h5>
                                <p>Founded with the vision of simplifying business operations, we have been delivering top-tier solutions and creating lasting relationships with our clients.</p>
                            </div>
                        </div>
                        <div className="about_box">
                            <div className="about_icon green_icon">
                                <FontAwesomeIcon icon={faChalkboardTeacher} />
                            </div>
                            <div className="about_content">
                                <h5>Our Team</h5>
                                <p>Our team consists of highly skilled professionals from diverse backgrounds, dedicated to providing exceptional services and advice to clients across industries.</p>
                            </div>
                        </div>
                        <div className="about_box">
                            <div className="about_icon blue_icon">
                                <FontAwesomeIcon icon={faShoppingCart} />
                            </div>
                            <div className="about_content">
                                <h5>Our Values</h5>
                                <p>Integrity, professionalism, and a customer-first approach are at the core of everything we do, ensuring that we always put our clients’ needs above all else.</p>
                            </div>
                        </div>
                    </div>

                    <div className="about_box_details">
                        <div className="about_col">
                            <div className="about_image">
                                <img src={AboutImage} alt="about" className="about_main"/>
                            </div>
                            <div className="img_info__box">
                                <h6 className="img_info__title">Get to Know Us Better</h6>
                                <p>Our team is ready to help you with personalized solutions to meet your business goals. Let's connect and start a conversation!</p>
                            </div>
                        </div>
                        <div className="about_col more_space">
                            <h3>Why Choose Us?</h3>
                            <p>We are passionate about helping your business grow and thrive by providing high-quality services and deep industry expertise.</p>

                            <div className="grid_info">
                                <div className="icon"><FontAwesomeIcon icon={faFileInvoice} /></div>
                                <div className="detail">
                                    <h4>Trusted Expertise</h4>
                                    <p>Our team’s extensive experience in multiple domains ensures the highest standard of service.</p>
                                </div>
                            </div>
                            <div className="grid_info">
                                <div className="icon green_icon"><FontAwesomeIcon icon={faPhone} /></div>
                                <div className="detail">
                                    <h4>Personalized Support</h4>
                                    <p>We offer one-on-one support to guide you through your journey with us, ensuring all your needs are met promptly.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
